import { render, staticRenderFns } from "./NavigationBurger.vue?vue&type=template&id=50956070&scoped=true&"
import script from "./NavigationBurger.vue?vue&type=script&lang=js&"
export * from "./NavigationBurger.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBurger.vue?vue&type=style&index=0&id=50956070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50956070",
  null
  
)

export default component.exports